<template>
  <div>
    <div class="container">
      <h3 class="text-center text-dark">Edit Your SoundCloud Songs</h3>
      <form>
        <div
          class="row my-5"
          v-for="(item, index) in soundCloud[0]"
          :key="index"
        >
          <div class="col-9">
            <div class="form-group mt-4">
              <label>SoundCloud Link</label>
              <input
                type="text"
                class="form-control"
                placeholder="Enter Link"
               :value="item"
              />
            </div>
          </div>
          <div class="col-3">
            <iframe
              width="100%"
              height="200px"
              scrolling="no"
              frameborder="no"
              allow="autoplay"
              :src="item"
              alt="piaraam video pedramjiravand youtube composer moving iranian_composer"
            ></iframe>
          </div>
          <div class="my-5 mx-auto">
            <button
              class="btn btn-primary"
              type="button"
              @click="submit(index)"
            >
              Update
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import db from "@/firebase/init.js";
export default {
  data() {
    return {
      soundCloud: [],
      soundCloudId: "",
      item: "",
    };
  },
  methods: {
    fetchData() {
      //fetch data from fire store
      db.collection("soundcloud")
        .get()
        .then((res) => {
          res.forEach((item) => {
            this.soundCloud.push(item.data().songs);
            this.soundCloudId = item.id;
            console.log(item.data());
          });
        })
        .catch((err) => console.log(err));
    },
    submit(index) {
      console.log(index);
      db.collection("soundcloud")
        .doc(this.soundCloudId)
        .update({ songs: [] })
        .then((res) => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch((err) => console.log(err));
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
